/* istanbul ignore file */
import { ErrorBoundary as ErrorBoundaryComponent } from '@ori/logger';
import type { FC, PropsWithChildren } from 'react';

import { FooterAppSkeleton } from './FooterAppSkeleton';

export const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => (
  <ErrorBoundaryComponent
    areaName="ErrorBoundary"
    fallback={<FooterAppSkeleton />}
  >
    {children}
  </ErrorBoundaryComponent>
);
